module.exports = {"previous":"&laquo; Precedente","next":"Successivo &raquo;"};